/**
 * Date / label helpers — ported 1:1 from the v1.1 (Blue) prototype.
 *
 * Every Intl call is pinned to en-US on purpose. Passing `undefined` would follow the
 * browser locale, which renders month names in the viewer's language.
 */

export const LOCALE = "en-US";

export const uid = () => Math.random().toString(36).slice(2, 10);

export const fmtDate = (d) => {
  if (!d) return "—";
  return new Date(d + "T00:00:00").toLocaleDateString(LOCALE, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const fmtDateTime = (d) =>
  new Date(d).toLocaleString(LOCALE, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

/** "Oct 7, 2026 · 14:30" when the reminder carries a time, the date alone otherwise. */
export const fmtReminderWhen = (r) => fmtDate(r.date) + (r.time ? " · " + r.time : "");

/**
 * Sort key for reminders: by day, then by time within the day. A reminder
 * without a time means "any time that day" and sorts after the timed ones.
 */
export const reminderSortKey = (r) => (r.date || "") + " " + (r.time || "99:99");

export const addDays = (base, n) => {
  const d = new Date(base);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const daysBetween = (a, b) =>
  Math.round((new Date(b) - new Date(a)) / 86400000);

export const initials = (name) =>
  (name || "")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const avatarColor = (moveType) =>
  moveType === "ld"
    ? "var(--purple)"
    : moveType === "storage"
      ? "var(--warning)"
      : "var(--primary)";

export const moveTypeLabel = (mt) =>
  mt === "ld" ? "LONG DISTANCE" : (mt || "").toUpperCase();

export const tagBadgeClass = (tag) => {
  if (tag === "LOCAL") return "local";
  if (tag === "LONG DISTANCE") return "ld";
  if (tag === "STORAGE") return "storage";
  if (String(tag).toUpperCase().includes("VIP")) return "vip";
  if (tag === "RISK") return "open";
  return "gray";
};

export const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const humanizeKey = (k) =>
  k.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());

export const plural = (n, s, p) => (n === 1 ? s : p || s + "s");

export const TEXT_TEMPLATES = [
  "Move date reminder",
  "Introduction message",
  "Confirmation request",
  "Missed you — please call back",
];

export const EMAIL_TEMPLATES = [
  "Introduction email",
  "Move date confirmation",
  "Documents needed",
  "Missed call follow-up",
];
